<template>
  <div v-if="entries.length" class="not-prose pb-4">
    <div class="flex items-center justify-between py-1 font-bold">
      <div class="flex items-center">
        Hinderungshistorie
        <span
          class="ml-1 inline-flex h-5 w-5 items-center justify-center rounded-md bg-dark-5 text-sm text-white shadow"
        >
          {{ entries.length }}
        </span>
      </div>

      <div
        v-if="entries.length > 1"
        class="flex cursor-pointer items-center"
        @click="toggleOlder"
      >
        <em
          class="mdi mdi-chevron-down mr-1 text-xl transition-transform"
          :class="{ 'rotate-180': showOlder }"
        />
        {{ showOlder ? 'Weniger anzeigen' : 'Alle anzeigen' }}
      </div>
    </div>

    <div
      class="flex items-center gap-3 pt-2 text-xs text-gray-500 dark:text-gray-400"
    >
      <span class="flex-1">Grund</span>
      <span>Status</span>
      <span class="w-40 shrink-0 text-right">Datum</span>
    </div>

    <div
      v-for="(entry, i) in entries"
      v-show="i === 0 || showOlder"
      :key="entry.id"
      :ref="
        (el) => {
          if (i === 1) olderRef = el as HTMLElement;
        }
      "
      class="flex items-center gap-3 py-2 border-b border-b-light-0 dark:border-b-dark-3 last:border-b-0"
    >
      <span class="flex-1">{{ reasonLabel(entry.reason) }}</span>
      <BaseChip
        v-if="entry.type"
        :text="impedimentTypes.find((t) => t.value === entry.type)?.name"
        :type="entry.type === ImpedimentType.PERMANENT ? 'danger' : 'warning'"
        :outlined="true"
      />
      <span class="w-40 shrink-0 text-right text-gray-500 dark:text-gray-400">
        {{ formatDateTime(entry.recordedAt ?? entry.timestamp ?? '') }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from 'vue';
import { Impediment } from '@/models/Impediment';
import { FailedInstallationAttempt } from '@/models/installationPoint/InstallationPoint';
import {
  ImpedimentType,
  impedimentTypes,
  impedimentReasonLabel,
} from '@/enums/generic';
import BaseChip from '@/components/UI/Chip/BaseChip.vue';
import { formatDateTime } from '@/utils/dateUtils';

type AnyImpedimentEntry = (Impediment | FailedInstallationAttempt) & {
  id: string;
  type?: ImpedimentType;
  reason?: string;
  recordedAt?: string;
  timestamp?: string;
};

const props = defineProps<{
  entries: AnyImpedimentEntry[];
}>();

function reasonLabel(reason?: string): string {
  return reason ? impedimentReasonLabel(reason) : '';
}

const showOlder = ref(false);
const olderRef = ref<HTMLElement | null>(null);

async function toggleOlder() {
  showOlder.value = !showOlder.value;
  if (showOlder.value) {
    await nextTick();
    olderRef.value?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}
</script>
